export default __webpack_public_path__ + "static/media/site_bis.81ed2730.webp";